import { useLayoutEffect } from 'react';
let activeLocks = 0;
let restoreLock;
/** One lock owns both scrolling elements and compensates the actual page gutter. */
export function useCapitalScrollLock(open, disabled) {
    useLayoutEffect(() => {
        if (!open || disabled)
            return;
        if (activeLocks++ === 0) {
            const root = document.documentElement;
            const body = document.body;
            const gutter = Math.max(0, window.innerWidth - root.clientWidth);
            const elements = [root, body];
            const saved = elements.map(element => ({ element, properties: ['overflow', 'overflow-x', 'overflow-y', 'padding-right'].map(property => ({
                    property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property),
                })) }));
            const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
            elements.forEach(element => { element.style.overflow = 'hidden'; });
            // Legacy layout sets body padding: 0 !important; compensation must win while locked.
            if (gutter)
                body.style.setProperty('padding-right', `${padding + gutter}px`, 'important');
            restoreLock = () => saved.forEach(({ element, properties }) => properties.forEach(({ property, value, priority }) => {
                if (value)
                    element.style.setProperty(property, value, priority);
                else
                    element.style.removeProperty(property);
            }));
        }
        return () => {
            if (--activeLocks === 0) {
                restoreLock === null || restoreLock === void 0 ? void 0 : restoreLock();
                restoreLock = undefined;
            }
        };
    }, [open, disabled]);
}
